var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Modal from 'bootstrap/js/dist/modal';
export class ModeratorDashboard extends Component {
    constructor() {
        super('ModeratorDashboard', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-accordion-next').on('click', (event, button) => {
                button.parents('.accordion-item').find('.accordion-button').removeClass('pe-none');
                button.parents('.accordion-item').next().find('.accordion-button').removeClass('pe-none');
            });
            $('.btn-reject-help-request').on('click', (event, button) => {
                if (!confirm('Êtes-vous sûr de vouloir refuser cette demande d’aide ?')) {
                    event.preventDefault();
                }
            });
            // Review modal
            if ($('#modal-review').length > 0) {
                new BS_Modal($('#modal-review').get(0), { backdrop: true, keyboard: false });
                $('#modal-review').on('show.bs.modal', (event) => __awaiter(this, void 0, void 0, function* () {
                    const content = yield $.httpRequest({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        body: {
                            action: 'hw_review_matching',
                            help_request_id: $(event.relatedTarget).data('helpRequestId'),
                            user_id: $(event.relatedTarget).data('userId'),
                        },
                        dataType: 'html'
                    });
                    $('#modal-review .modal-dynamic-content').append(content);
                    $('#modal-review .modal-spinner').addClass('d-none');
                    let btnSuccessHref = $('#modal-review .btn-success').attr('href');
                    btnSuccessHref = btnSuccessHref.replace(/id=[0-9]*/, `id=${$(event.relatedTarget).data('helpRequestId')}`);
                    btnSuccessHref = btnSuccessHref.replace(/user_id=[0-9]*/, `user_id=${$(event.relatedTarget).data('userId')}`);
                    console.log(btnSuccessHref);
                    $('#modal-review .btn-success').attr('href', btnSuccessHref);
                }));
            }
            // Feedback form modal
            if ($('#modal-feedback').length > 0) {
                new BS_Modal($('#modal-feedback').get(0), { backdrop: true, keyboard: false });
                $('#modal-feedback').on('show.bs.modal', (event) => __awaiter(this, void 0, void 0, function* () {
                    const content = yield $.httpRequest({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        body: {
                            action: 'hw_get_feedback_form',
                            entry_id: $(event.relatedTarget).data('entryId'),
                        },
                        dataType: 'html'
                    });
                    $('#modal-feedback .modal-dynamic-content').append(content);
                    $('#modal-feedback .modal-spinner').addClass('d-none');
                }));
            }
            // Common modal behavior
            $('.modal').on('hidden.bs.modal', (event) => __awaiter(this, void 0, void 0, function* () {
                $('.modal .modal-dynamic-content').empty();
                $('.modal .modal-spinner').removeClass('d-none');
            }));
            this.success();
        });
    }
}
